import React, { useState, useEffect } from 'react'
import './loadingScreen.css'
import logo from '../../assets/logo.png'

const LoadingScreen = ({ assetsLoading }) => {
  const [loadingDisplay, setLoadingDisplay] = useState(true)
  const [progress, setProgress] = useState(0)

  const loadingStatus = (!assetsLoading.nebula && !assetsLoading.logo && !assetsLoading.aries && !assetsLoading.taurus && !assetsLoading.gemini && !assetsLoading.cancer && !assetsLoading.leo && !assetsLoading.virgo && !assetsLoading.libra && !assetsLoading.scorpio && !assetsLoading.sagittarius && !assetsLoading.capricorn && !assetsLoading.aquarius && !assetsLoading.pisces && !assetsLoading.red && !assetsLoading.maroon && !assetsLoading.yellow && !assetsLoading.orange && !assetsLoading.lightGreen && !assetsLoading.green && !assetsLoading.aqua && !assetsLoading.skyBlue && !assetsLoading.blue && !assetsLoading.purple && !assetsLoading.white && !assetsLoading.black) ? false : true

  useEffect(() => {
    const changeStateFunction = () => {
      if (loadingStatus === false) {
        setLoadingDisplay(false)
      } else {
        setLoadingDisplay(true)
      }
    }

    const timeOutFunction = setTimeout(() => changeStateFunction(), 1000);

    return () => clearTimeout(timeOutFunction)
  }, [loadingStatus])

  useEffect(() => {
    let totalKeys = Object.keys(assetsLoading).length
    let totalValues = Object.values(assetsLoading)
    let loaded = 0

    for (let i = 0; i < totalValues.length; i++) {
      if (totalValues[i] === false) {
        loaded++
      }
    }
    
    setProgress((loaded / totalKeys) * 100)
  }, [assetsLoading])

  return (
    <div className="loadingScreen" style={{ display: (loadingDisplay) ? 'flex' : 'none', opacity: (loadingStatus) ? 1 : 0 }}>
    {/* <div className="loadingScreen" style={{ display: 'flex', opacity: 1 }}> */}
      {/* <div className="loading-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <img src={logo} alt="logo" />
      </div> */}

      <div className="loading-percentage">
        <div className='loading-logo'>
          <img src={logo} alt="logo" />
          Horoscopo
        </div>

        <div className="loading-progress">
          <p>{progress.toFixed(0)}%</p>
          <div>
            <div style={{ width: `${progress}%` }}></div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default LoadingScreen